// config/constants.js

export const SUBSCRIPTION_STATES = {
    // Request States
    PENDING_ADMIN: 'pending_admin',      // Initial state when client submits request
    PENDING_PAYMENT: 'pending_payment',   // After admin approves, waiting for client payment
    PAYMENT_SUBMITTED: 'payment_submitted', // Client submitted payment proof, waiting for admin verification
    
    // Active States
    ACTIVE: 'active',                    // Subscription is active
    
    // Terminal States
    REJECTED: 'rejected',                // Admin rejected the request
    EXPIRED: 'expired',                  // Subscription has expired
    CANCELLED: 'cancelled'               // Client cancelled the subscription
};

export const SUBSCRIPTION_STATUS_LABELS = {
    [SUBSCRIPTION_STATES.PENDING_ADMIN]: 'Pending Admin Approval',
    [SUBSCRIPTION_STATES.PENDING_PAYMENT]: 'Payment Required',
    [SUBSCRIPTION_STATES.PAYMENT_SUBMITTED]: 'Payment Verification Pending',
    [SUBSCRIPTION_STATES.ACTIVE]: 'Active',
    [SUBSCRIPTION_STATES.REJECTED]: 'Rejected',
    [SUBSCRIPTION_STATES.EXPIRED]: 'Expired',
    [SUBSCRIPTION_STATES.CANCELLED]: 'Cancelled'
};